import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import baseInfo from './modules/base-info'
import resource from './modules/resource'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    baseInfo,
    resource
  }
})



// WEBPACK FOOTER //
// ./src/sso/store/index.js